import angular from 'angular';
import creditChecksList from './creditChecksList';
import './style.scss';

export default angular
  .module('components.creditChecksList', [])
  .component('creditChecksList', creditChecksList).name;
